<div class="max-w-6xl mx-auto mt-4 pb-6">
  <div class="rounded-larger shadow-lg overflow-hidden" *ngIf="school?.imgAboutUs && school?.aboutUsText">
    <ts-picture [img]="school.imgAboutUs"> </ts-picture>
  </div>
  <div class="mt-4" *ngIf="school?.aboutUsText">
    <h1 class="font-bold text-xl">Über die {{ school.name }}</h1>
    <div class="text-gray-600 text-sm" [innerHTML]="school.aboutUsText"></div>
  </div>
</div>
